import { styled } from '../../../core/theme/styled';

export const UnverifiedWrapper = styled.div`
  display: flex;
  font-size: ${(props) => props.theme.sizes.small};
  line-height: ${(props) => props.theme.sizes.normal};
  margin-bottom: ${(props) => props.theme.sizes.small};
  padding: ${(props) => props.theme.sizes.xsmall};
  color: ${(props) => props.theme.palette.red.main};
  border: 1px solid ${(props) => props.theme.configuration.errorTextColor};
  border-radius: ${(props) => props.theme.roundedCorners.xsmall};
  background-color: ${(props) => props.theme.palette.white.main};
  flex-shrink: 0;
`;
